import React from 'react';

const DeviceView = ({ deviceName, deviceWidth, deviceHeight, activeTheme, language, clientName, selectedLayout, font, carbon, rating,addcss,mode,brandColor, seasonBrand, ProductCount}) => {
  // Constructing the template URL as per the new format
  let templateURL = `/iniframe?color=${activeTheme}&language=${language}&clientName=${clientName}&layout=${selectedLayout}&font=${font}&carbon=${carbon}&rating=${rating}&addcss=${addcss}&mode={mode}&brandColor=${brandColor}&seasonBrand=${seasonBrand}&ProductCount=${ProductCount}`;

  return (
    <>
      <div className="mt-1">
        <div className={deviceName}>
          <div className="content text-center">
            <iframe src={templateURL} width={deviceWidth} height={deviceHeight} frameBorder="0" />
          </div>
        </div>
      </div>
      {(selectedLayout === "layout-bill" || 
        selectedLayout === "layout-full" || selectedLayout === "layout-simple" || 
        selectedLayout === "layout-small") && (
        <style>{`body div#root div.wrapper{text-align:center;}`}</style>
      )}
    </>
  );
};

export default DeviceView;
